export default __webpack_public_path__ + "static/media/melat.9cdcaee1.png";